
import PropTypes from 'prop-types';
import React from 'react';
import { Modal, Checkbox } from '../../components';
import _ from 'lodash';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { Divider } from '@material-ui/core';
import { styles } from './ShopModal.styles';
import { withStyles } from '@material-ui/core/styles';
import { getShopsToSynchronise } from 'src/utils/shopUtils';
import { hasExternalIntegration } from 'src/utils/externalIntegration';

const getConnexionName = (shop, index) => {
  const hasIntegration = hasExternalIntegration(index);
  const { externalIntegration = {} } = shop?.configuration
  const { configuration = {} } = externalIntegration
  const { withoutMenuIntegrated = false } = configuration;
  if (hasIntegration && !withoutMenuIntegrated) {
    return `(Connexion ${hasIntegration})`
  }
  return '(Sans connexion)'
}
const ShopModal = ({ classes, shopId, showModal, selectedShops, loading, onClick, handleToggle, component, text, title, isSuppression }) => {
  const numSelected = _.size(selectedShops);
  const shopsToSync = getShopsToSynchronise();
  const nbShopsToSync = _.size(shopsToSync);
  const sortedShops = _.keys(shopsToSync)
    .sort((a, b) => shopsToSync[a]?.name?.localeCompare(shopsToSync[b].name))
    .reduce((obj, cur) => ({ ...obj, [cur]: shopsToSync[cur] }), {});
  return (
    <Modal
      color='secondary'
      title={title}
      header
      fixed
      size='md'
      loading={loading}
      showCancelBtn
      btnTxt={`${isSuppression ? 'Supprimer' : 'Synchroniser'}`}
      modalBodyClass='py-0'
      onClick={onClick}
      isOpen={showModal}
      handleClose={() => component.setState({ showModal: false })}
    >
      <List>
        <ListItem>
          <h5>{text}</h5>
        </ListItem>
        <div className={classes.listStyle}>
          {nbShopsToSync > 2 &&
            <ListItem
              button
              className={classes.itemStyle}
              key='all'
              onClick={() =>
                component.setState({
                  selectedShops:
                    nbShopsToSync > 0 && numSelected === nbShopsToSync ? { [shopId]: shopsToSync[shopId] } : shopsToSync
                })
              }
            >
              <ListItemIcon>
                <Checkbox
                  value={nbShopsToSync > 0 && numSelected === nbShopsToSync}
                  inputProps={{ 'aria-label': 'select all' }}
                  text={<p className={classes.titleStyle}>Tout sélectionner</p>}
                  className='pt-0 my-0'
                />
              </ListItemIcon>
            </ListItem>}
          <Divider />
          {_.map(sortedShops, (shop, index) => {
            return (
              index !== shopId && (
                <React.Fragment key={shop.name}>
                  <ListItem
                    className={classes.itemStyle}
                    button
                    onClick={() => handleToggle(shop, index, component)}
                  >
                    <ListItemIcon>
                      <Checkbox
                        value={_.keys(selectedShops).indexOf(index) !== -1}
                        inputProps={{ 'aria-labelledby': shop.name }}
                        text={
                          < div className={classes.flexContainer}>
                            <p className={`${classes.titleStyle} mr-2`}>{shop.name}</p>
                            <small className={classes.connexionName}>{getConnexionName(shop, index)}</small>
                          </div>
                        }
                        className='pt-0'
                      />
                    </ListItemIcon>
                  </ListItem>
                  {_.findLast(sortedShops) !== shop && <Divider key={`divider-${index}`} />}
                </React.Fragment>
              )
            );
          })}
        </div>
      </List>
    </Modal>
  );
};

ShopModal.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default (withStyles(styles)(ShopModal));
